export default __webpack_public_path__ + "static/media/callcenter_bg.e0b16572.jpg";